import { ArtifactEditor } from '@/components/artifact/ArtifactEditor'
import { useArtifactStore } from '@/store/artifactStore'
import { useUIStore } from '@/store/uiStore'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/editor/$id')({
  component: () => <EditorPage />
})

function EditorPage() {
  const { id } = Route.useParams()
  const artifacts = useArtifactStore((state) => state.artifacts)
  const loadArtifacts = useArtifactStore((state) => state.loadArtifacts)
  const { setCurrentView, setSelectedArtifactId } = useUIStore()

  const artifact = artifacts.find(a => a.id === id)

  useEffect(() => {
    if (artifacts.length === 0) {
      loadArtifacts()
    }
  }, [artifacts.length, loadArtifacts])

  useEffect(() => {
    setCurrentView('editor')
    setSelectedArtifactId(id)
  }, [id, setCurrentView, setSelectedArtifactId])

  // Update document title
  useEffect(() => {
    if (artifact) {
      document.title = `${artifact.title} - Artifacts`
    } else {
      document.title = 'Editor - Artifacts'
    }
  }, [artifact])

  if (!artifact && artifacts.length > 0) {
    return (
      <div className="error-state">
        <h2>Artifact Not Found</h2>
        <p>The artifact with ID "{id}" could not be found.</p>
      </div>
    )
  }

  if (!artifact) {
    return (
      <div className="loading-state">
        <p>Loading artifact...</p>
      </div>
    )
  }

  return <ArtifactEditor artifact={artifact} />
} 